<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()"
	*ngIf="doctemplate && !loading">
	<div class="modal-header">
		<h4 class="modal-title">
			{{(doctemplate.id ? 'labels.doctemplate-edit' : 'labels.doctemplate-create') | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && doctemplate">
			<div class="col-sm-12">

				<div class="row">
					<!-- entity -->
					<div class="form-grpup col-md-4">
						<label>{{'labels.entity' | translate}}*</label>
						<select
							#entity="ngModel"
							class="form-control custom-select"
							[(ngModel)]="doctemplate.entity"
							name="entity">
							<option
								*ngFor="let entity of docTemplateTypes"
								[value]="entity.value">
								{{'types.doctemplate-types.'+ entity.value | translate}}
							</option>
						</select>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && entity.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- fname -->
					<div class="form-group col-md-4">
						<label for="name">{{ 'labels.name' | translate }}*</label>
						<input
							[(ngModel)]="doctemplate.name"
							#name="ngModel"
							name="name"
							required
							(blur)="autoSlug()"
							type="text"
							class="form-control"
							id="name"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
					<!-- slug -->
					<div class="form-group col-md-4">
						<label for="slug">{{ 'labels.slug' | translate }}*</label>
						<input
							[(ngModel)]="doctemplate.slug"
							#slug="ngModel"
							name="slug"
							required
							type="text"
							class="form-control"
							id="slug"
							placeholder="{{ 'labels.slug' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && slug.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && slug.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4 mt-4 mb-2">

						<el-attachment-input
							#attachment
							[autoupload]="canupload"
							(uploadcomplete)="uploadcomplete($event)"
							[custompath]="'/ws/doctemplate/' + doctemplate.id + '/upload'">
						</el-attachment-input>
						{{doctemplate.filename}}
					</div>

				</div>
			</div>
		</div>
		<div class="modal-footer">

			<button
				type="reset"
				class="btn btn-secondary">
				{{'labels.reset' | translate}}
			</button>
			<button
				type="button"
				class="btn btn-secondary"
				(click)="dismiss()">
				{{'labels.cancel' | translate}}
			</button>
			<button
				type="submit"
				class="btn btn-primary">
				{{'labels.save' | translate}}
			</button>
		</div>
	</div>
</form>
